<template>
    <!-- DESCR：会议论文提交描述页面 -->
    <div class="pagepaper-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">{{ conferenceinfo.acronym }} ({{ conferenceinfo.title }})</div>
                    <br />
                    <div class="info">
                        This is the submission page for {{ conferenceinfo.acronym }}. Below are some important
                        information
                        about the conference.
                    </div>
                    <div class="info">
                        If you need to submit a paper, you can click on the corresponding submission button below
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 会议的详细信息 -->
        <el-row :gutter="10" justify="center">
            <el-col :span="24" class="conferencebox">
                <div class="conferencebg">
                    <span class="text-line">{{ conferenceinfo.acronym }}: {{ conferenceinfo.title }}</span>
                    <br />
                    <div>{{ conferenceinfo.city }}, {{ conferenceinfo.country }}, {{ conferenceinfo.date }}</div>
                </div>
                <el-descriptions :column="1" :size="size" border>
                    <el-descriptions-item>
                        <template #label>
                            <div class="desc-item-text">Conference website</div>
                        </template>
                        <el-tag size="small">
                            {{ conferenceinfo.webpage }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="desc-item-text">Submission link</div>
                        </template>
                        <el-tag size="small">
                            {{ conferenceinfo.sublink }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="desc-item-text">Abstract registration deadline</div>
                        </template>
                        <el-tag size="small">
                            {{ conferenceinfo.regdeadline }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="desc-item-text">Submission deadline</div>
                        </template>
                        <el-tag size="small">
                            {{ conferenceinfo.subdeadline }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template #label>
                            <div class="desc-item-text">Has it been submitted</div>
                        </template>
                        <div v-if="conferenceinfo.isjoin == true">
                            <el-tooltip class="box-item" effect="dark"
                                :content="`${conferenceinfo.papernum} papers have been submitted`" placement="right">
                                <el-badge type="primary" is-dot>
                                    <el-tag size="small">
                                        Submitted
                                    </el-tag>
                                </el-badge>
                            </el-tooltip>
                        </div>
                        <div v-else>
                            <el-tag size="small">Unsubmitted</el-tag>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </el-col>
        </el-row>
        <el-row :gutter="10" justify="center">
            <el-col :span="21" style="display:flex;justify-content: center;margin-top:40px">
                <el-button type="success" style="width:200px" @click="authorpaper">contributed paper</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import request from "../../network/request"
import { useStore } from 'vuex'
import { ArrowLeftBold } from '@element-plus/icons-vue'


const route = useRoute();
const router = useRouter();
const store = useStore();
const conferenceinfo = ref({})
const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

// 日期格式调整（调整为会议日期连）
function dateUtilsSplit(firstday, lastday) {
    let engmonth = month[Number(lastday.split("-")[1].replace("0", "")) - 1]
    let engtimesplit = firstday.split("-")[2] + "-" + lastday.split("-")[2]
    let engyear = firstday.split("-")[0]
    return engmonth + " " + engtimesplit + "," + engyear;
}


// 日期格式调整（调整为会议创建的前一天）
function dateUtilsNear(date) {
    let nearDate = new Date(date.split("-"))
    nearDate = nearDate.setDate(nearDate.getDate() - 1);
    nearDate = new Date(nearDate);
    let y = nearDate.getFullYear()
    let m = (nearDate.getMonth() + 1).toString().padStart(2, '0')
    let d = nearDate.getDate().toString().padStart(2, '0')
    let engmonth = month[Number(m) - 1]
    return engmonth + " " + d + ", " + y;
}

// 论文投稿
const authorpaper = () => {
    router.push(`/common/createpaper/?cid=${conferenceinfo.value.cid}&acronym=${conferenceinfo.value.acronym}&title=${conferenceinfo.value.title}&subnum=${conferenceinfo.value.subnum}`)
}


onMounted(() => {
    console.log("进入链接了")


    // 清除菜单索引
    store.commit('setMenuItemIndex', '')

    // 获取会议详细信息
    request.post("/conference/detail", {
        sublink: route.query.conf
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        conferenceinfo.value.cid = res.data.cid
        conferenceinfo.value.acronym = res.data.acronym
        conferenceinfo.value.title = res.data.title
        conferenceinfo.value.city = res.data.city
        conferenceinfo.value.country = res.data.country
        conferenceinfo.value.date = dateUtilsSplit(res.data.lastday, res.data.lastday)
        conferenceinfo.value.webpage = res.data.webpage
        conferenceinfo.value.subnum = res.data.subnum
        conferenceinfo.value.sublink = "https://www.gdstinfo.cn/conferences?conf=" + res.data.sublink
        conferenceinfo.value.regdeadline = dateUtilsNear(res.data.lastday)
        conferenceinfo.value.subdeadline = dateUtilsNear(res.data.lastday)
        conferenceinfo.value.isjoin = res.data.isJoin
        conferenceinfo.value.papernum = res.data.papernum
    })
})
</script>


<style lang="scss">
.pagepaper-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .office-dia {
        .vue-office-pdf-wrapper {
            padding: 0px !important;
        }
    }

    .pagebg {
        background-color: #cce0f57a !important;
    }

    .login-title {
        // background-color: #f6f4f2;
        margin-bottom: 30px;
        padding: 20px 0;

        div {
            padding-left: 50px;
            font-size: 16px;
            padding-right: 300px;

            div:nth-child(1) {
                font-weight: 700;
                font-size: 20px;
            }

            div:nth-child(3) {
                font-size: 13px;
            }

            div:nth-child(5) {
                font-size: 13px;
            }
        }
    }



    .authorbtn {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 50px 0 20px 0;

    }

    .status {
        margin-top: 0px;
    }

    .submit {
        padding-left: 260px;
        width: 100%;

        .el-button {
            width: 300px;
        }
    }

    .reviews {
        margin-bottom: 30px;
        box-shadow: 1px 2px 3px #00000023;

        td {
            border: 0 !important;
        }

        .title {
            text-align: center;
            background-color: rgb(147 181 194 / 73%);
            padding: 2px;
            color: #f9f8f8;
        }
    }



    .conferencebg {
        background-color: #b7dffd3b;
        padding: 30px;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
        font-size: 13px;
        color: #4f5b6a;

        .text-line {
            border-bottom: 2px dotted #1f74f770;
            display: inline-block;
            margin-bottom: 10px;
            padding-bottom: 5px;
        }

    }

    .desc-item-text {
        padding-left: 15px;
    }
}
</style>